<div class="body-component">
    <div class="row">
        <div class="col-6">
            <div class="shelves-status">
                <span *ngIf="progressBarLoops">
                    {{ progressBarLoops.totalLoop }}
                </span>
                <span>
                    {{ "total-shelves" | lang | uppercase }}
                </span>
            </div>
        </div>
        <div class="col-6">
            <div class="shelves-status">
                <span *ngIf="progressBarLoops">
                    {{ progressBarLoops.scheduledLoop }}
                </span>
                <span>
                    {{ "scheduled-shelves" | lang | uppercase }}
                </span>
            </div>
        </div>
    </div>
    <div class="progress progress-bar-percent">
        <div
            class="progress-bar progress-total-shelves"
            role="progressbar"
            [ngStyle]="{
                width:
                    totalShelvesPercent === '0%' ? '0.5%' : totalShelvesPercent
            }"
            [ngbTooltip]="totalTooltip"
            tooltipClass="tooltip-container"
        ></div>
        <div
            class="progress-bar progress-scheduled-shelves"
            role="progressbar"
            [ngStyle]="{
                width:
                    scheduledShelvesPercent === '0%'
                        ? '0.5%'
                        : scheduledShelvesPercent
            }"
            [ngbTooltip]="scheduledTooltip"
            tooltipClass="tooltip-container"
        ></div>
    </div>
    <div
        class="d-flex justify-content-center buttons-container legend-container"
    >
        <div class="legend">
            <div class="dot"></div>
            <span>{{ "total-shelves" | lang }}</span>
        </div>
        <div class="legend">
            <div class="dot"></div>
            <span>{{ "scheduled-shelves" | lang }}</span>
        </div>
    </div>

    <app-first-last-loop-modal
        [firstLoop]="firstLoop"
        [lastLoop]="lastLoop"
    ></app-first-last-loop-modal>
</div>

<ng-template #totalTooltip>
    <div class="tooltip-legend total-shelves-legend"></div>
    <span [ngStyle]="{ 'font-size': '11px' }">
        {{ totalShelvesPercent }} - {{ "total-shelves" | lang }}
    </span>
</ng-template>

<ng-template #scheduledTooltip>
    <div class="tooltip-legend scheduled-shelves-legend"></div>
    <span [ngStyle]="{ 'font-size': '11px' }">
        {{ scheduledShelvesPercent }} - {{ "scheduled-shelves" | lang }}
    </span>
</ng-template>

<div *ngIf="showHasTable && componentName === 'total-extraction'">
    <app-total-extraction-table
        *ngIf="hasDataTable"
        [totalExtraction]="totalExtractionTable"
    ></app-total-extraction-table>
</div>
